import React, { useEffect, useState, useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  OutlinedPrimaryButton,
  PrimaryButton,
} from "../../../../components/ui/Button";
import { useDispatch } from "react-redux";
import { PaymentTermLoanContext } from "../../../../hooks/context";
import { InputField } from "../../../../components/ui/Inputs";
import WestIcon from "@mui/icons-material/West";
import {
  encryptObject,
  decryptObject,
  decrypt,
} from "../../../../utils/crypto";
import postsServices from "../../../../services/api/service/postsService";
import ButtonLoader from "../../../../components/ui/ButtonLoader";
import { setStatusPopup } from "../../../../services/redux/slices/statusPopupSlice";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export interface RowData {
  [key: string]: string | number | null;
}

const ProceedToPayLoan = () => {
  const {
    isXsOrSm,
    setFormStep,
    setFormValue,
    formValue,
    userProfile,
    applicableCharges,
    setTermLoanRequestId,
    selectedLoanNumber,
    setAmountValue,
    handleEmptyFormValue,
    loanCategoryValue,
  }: any = useContext(PaymentTermLoanContext);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  // Pre-Payment Charges (2% of total amount + 18% GST) computed in step 1
  // and persisted to the shared form value. Used to mirror step 1 fields here.
  // const prePaymentCharges: number = Number(formValue?.prePaymentCharges) || 0;

  // Net Principal Adjustment = Total Amount - (Pre-Payment Charges + Amort Updation Charges)
  // const netPrincipalAdjustment: number = (() => {
  //   const value =
  //     Number(formValue?.amount) - (prePaymentCharges + applicableCharges);
  //   return value > 0 ? value : 0;
  // })();

  const handleSubmit = async () => {
    try {
      const copyFormValue = { ...formValue };

      copyFormValue["cif"] = decrypt(userProfile?.cifNumber);
      copyFormValue["cifEntity"] = decrypt(userProfile?.cifEntity);
      copyFormValue["lan"] = selectedLoanNumber;
      copyFormValue["initiatedBy"] = decrypt(userProfile?.id);
      copyFormValue["paymentType"] = "PartPayment";
      copyFormValue["netPrincipalAdjustment"] =
       Number(formValue?.amount) - applicableCharges;
        // Number(formValue?.amount) -
        // (prePaymentCharges + applicableCharges);
      // loanCategory,business
      copyFormValue["loanCategory"] = loanCategoryValue?.loanCategoryId;
      copyFormValue["business"] = loanCategoryValue?.businessId;

      setIsLoading(true);
      const encryptedData = encryptObject(copyFormValue);
      await postsServices
        .addPost("/api/v1/payment/term-loan-data-processed", {
          data: encryptedData,
        })
        .then((response: any) => {
          setTermLoanRequestId(response?.data?.data?.termLoanRequestId);
          localStorage.setItem(
            "termLoanRequestId",
            response?.data?.data?.termLoanRequestId
          );
          setFormStep(3);
          setIsLoading(false);
          setAmountValue(null);
          handleEmptyFormValue();
        })
        .catch((error: any) => {
          const errorMessage = error?.response?.data?.message;
          dispatch(
            setStatusPopup({
              status: "error",
              message: errorMessage,
            })
          );
          setIsLoading(false);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <Grid item sm={12} className="form-container">
      <Box>
        <Typography className="section-sub-heading mb-10 mt-20">
          REVIEW DETAILS
        </Typography>
      </Box>
      <Grid
        container
        item
        spacing={2}
        mb={2}
        sx={{ paddingTop: "16px", alignItems: "center" }}
      >
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <div style={{ marginBottom: "2px" }}>
            <label
              htmlFor="custom-autocomplete"
              className="disbursement-inside-page-lable"
            >
              Total Amount
            </label>
          </div>
          <InputField
            fullWidth
            placeholder="Enter desired Pre-Payment amount"
            type="number"
            autoComplete="off"
            disabled
            value={formValue?.amount}
          />
        </Grid>
        {/* <Grid item xs={12} sm={3} md={3} lg={3}>
          <div style={{ marginBottom: "2px" }}>
            <label
              htmlFor="custom-autocomplete"
              className="disbursement-inside-page-lable"
            >
              Pre-Payment Charges
            </label>
          </div>
          <InputField
            fullWidth
            placeholder="Pre-Payment charges"
            type="number"
            autoComplete="off"
            disabled
            value={prePaymentCharges}
          />
        </Grid> */}
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <div style={{ marginBottom: "2px" }}>
            <label
              htmlFor="custom-autocomplete"
              className="disbursement-inside-page-lable"
            >
               Applicable Charges
              {/* Amort Updation Charges */}
            </label>
          </div>
          <InputField
            fullWidth
            placeholder="Enter Applicable charges"
            type="number"
            autoComplete="off"
            disabled
            value={applicableCharges}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <div style={{ marginBottom: "2px" }}>
            <label
              htmlFor="custom-autocomplete"
              className="disbursement-inside-page-lable"
            >
              Net Principal Adjustment
            </label>
          </div>
          <InputField
            fullWidth
            placeholder="Enter Net principle adjustment"
            type="number"
            autoComplete="off"
            disabled
            value={Number(formValue?.amount) - applicableCharges}
            // value={netPrincipalAdjustment}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="center" // Center the buttons horizontally
        alignItems="center"
        spacing={2} // Maintain spacing between items
        mt={1}
        mb={isXsOrSm ? 2 : 0}
      >
        <Grid item xs={6} sm={6} md={6} lg={6} container justifyContent="left">
          <OutlinedPrimaryButton
            width={isXsOrSm ? "112px" : "129px"}
            height={isXsOrSm ? "30px" : "42px"}
            fullWidth={true}
            onClick={() => setFormStep(1)}
            disabled={isLoading}
          >
            <WestIcon sx={{ fontSize: "17px" }} /> Previous
          </OutlinedPrimaryButton>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} container justifyContent="right">
          <PrimaryButton
            fullWidth={true}
            width={isXsOrSm ? "170px" : "162px"}
            height={isXsOrSm ? "30px" : "42px"}
            onClick={() => handleSubmit()}
            disabled={isLoading}
            fontSize={isXsOrSm ? "13px" : "15px"}
          >

            <ButtonLoader title={"Proceed To Pay"} isLoading={isLoading} /> &nbsp; <ArrowForwardIcon sx={{ fontSize: isXsOrSm ? "14px" : "17px" }} />
          </PrimaryButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProceedToPayLoan;
